import { useState } from 'react'
import { IconButton } from '../IconButton'
import { Tooltip } from '../Tooltip'

interface CopyButtonProps {
  text: string
}

const CopyButton = ({ text }: CopyButtonProps) => {
  const [copied, setCopied] = useState(false)

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(text)
      setCopied(true)
      setTimeout(() => setCopied(false), 2000)
    } catch (err) {
      console.error('Failed to copy:', err)
    }
  }

  return (
    <Tooltip content='Copy to clipboard'>
      <IconButton icon={copied ? 'Check' : 'Copy'} onClick={handleCopy} aria-label='Copy message' size='sm' />
    </Tooltip>
  )
}

export default CopyButton
